import Vue from 'vue'
import Vuex from 'vuex'
import { getArea , getCinema } from '@/views/filmclient/js/api';
let citySelect  = JSON.parse(localStorage.getItem('citySelect'))||null;
export default{
    state : {
        areaList:[],
        cinemaList:[],
        defarea:{},
        defcinema:{},
        citySelect:citySelect,
    },
    mutations: {
        //电影院区域数据
        SET_AREA(state,data){
          state.film.defarea = data[0]
          state.film.areaList = data
        },
        //电影院影院数据
        SET_CINEMA(state,data){
          state.film.defcinema = data[0]
          state.film.cinemaList = data
        },
    
        //电影院城市数据
        // setRrgion(state,sign){
        //   state.film.citySelect = sign
          
        //   if(id !== '' && id !== null){
        //     localStorage.setItem('citySelect',sign)
        //   }else{
        //     localStorage.removeItem('citySelect')
        //   }
        // }
      },
      actions: {
        /* 获取区域信息 */
        async getArea({
          commit,
          state
        },sign) {
    
          if(sign===undefined){
            sign=citySelect.city_sign
            
          }
    
          await getArea({access_token:state.film.testToken,city_sign:sign}).then(res=>{
            if (res.code == 200) {
              commit('SET_AREA',res.data.list)
            }else if(res.code != 200){
              this.$message.warning(res.msg);
            }
          }).catch();
    
          await getCinema({access_token:state.film.testToken,page:1,limit:100,area_sign:state.film.defarea.area_code}).then(res=>{
            if (res.code == 200) {
              commit('SET_CINEMA',res.data.list)
            }else if(res.code != 200){
              this.$message.warning(res.msg);
            }
          }).catch();
        },
        /* 获取影院信息 */
        async getCinema({
          commit,
          state
        },sign) {
          await getCinema({access_token:state.film.testToken,page:1,limit:100,area_sign:sign}).then(res=>{
            if (res.code == 200) {
              commit('SET_CINEMA',res.data.list)
            }else if(res.code != 200){
              this.$message.warning(res.msg);
            }
          }).catch();
        },
    
      },
}

